//mui
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
var DeviceBreakPoints = function DeviceBreakPoints() {
  var theme = useTheme();
  var isMediumDevice = useMediaQuery(theme.breakpoints.down('md'));
  var onlyMediumDevice = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  var isSmallDevice = useMediaQuery(theme.breakpoints.down('sm'));
  var isLargeDevice = useMediaQuery(theme.breakpoints.down('lg'));
  return {
    isMediumDevice: isMediumDevice,
    isSmallDevice: isSmallDevice,
    isLargeDevice: isLargeDevice,
    onlyMediumDevice: onlyMediumDevice,
    theme: theme
  };
};
export default DeviceBreakPoints;